import { useLang } from '@/i18n';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSectionCard from 'eco-design/sections/eco-section-card';
import styles from './index.module.scss';
import { useEffect, useState } from 'react';
export default function Comp() {
    const { t } = useLang('powerBank.I');

    return (
        <div className={`temp-section-3 ${styles.comp} Rapid-I GtmModuleData-section`} data-section-id="Rapid-I" id="section-3">
            <EcoSectionCard
                layout="img-right"
                label={t('label')}
                title={t('title')}
                desc={t('desc')}
                isOpenLazy={true}
                //不能压缩，压缩后有摩尔纹
                pc="https://websiteoss.ecoflow.com/upload/image/1753259273992/Frame%201612707660.png"
                className={styles.comp}
            />
            {/* <EcoSpace /> */}
        </div>
    );
}
